import React from 'react'
import { useUser, useAuthLoading } from '@/store/hooks'
import AdminDashboard from '@/pages/admin/AdminDashboard'
import StaffDashboard from '@/pages/staff/StaffDashboard'
import MemberDashboard from '@/pages/member/MemberDashboard'
import DepartmentHeadDashboard from '@/pages/department/DepartmentHeadDashboard'
import WorkerDashboard from '@/pages/worker/WorkerDashboard'
import { LoadingSpinner } from '@/components/ui/LoadingSpinner'

const DynamicDashboard = () => {
  const user = useUser()
  const isLoading = useAuthLoading()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" text="Loading dashboard..." />
      </div>
    )
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h2>
          <p className="text-gray-600">Please log in to access your dashboard.</p>
        </div>
      </div>
    )
  }

  // Route to appropriate dashboard based on user role
  switch (user.role) {
    case 'universal_admin':
    case 'office_admin':
      return <AdminDashboard />
    
    case 'department_head':
      return <DepartmentHeadDashboard />
    
    case 'front_worker':
      return <WorkerDashboard />
    
    case 'member':
      return <MemberDashboard />
    
    default:
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Unknown Role</h2>
            <p className="text-gray-600">Your account role is not recognized. Please contact support.</p>
          </div>
        </div>
      )
  }
}

export default DynamicDashboard

